import React from "react";
import { connect, useDispatch } from "react-redux";
import { PageHeader, Card } from "antd";
import Table from "./Table";
import Socket from "@/ui/Socket";
import { SET_APP, GET_AUDIOS } from "@/actions/app";
import "./index.less";

const Screen = (props) => {
  const { data, history, loading } = props;

  const dispatch = useDispatch();
  const socket = React.useRef();

  React.useEffect(() => {
    dispatch(SET_APP(["notification"], null));
    dispatch(GET_AUDIOS());
    socket.current = Socket("audios");
    socket.current.on("audio-added", () => {
      dispatch(GET_AUDIOS());
    });
    return () => {
      socket.current.disconnect();
    };
  }, [dispatch]);

  return (
    <>
      <PageHeader title="Аудиоролики" />
      <Card bordered={false}>
        <Table dataSource={data} loading={loading} history={history} />
      </Card>
    </>
  );
};

const mapStateToProps = (state) => ({
  data: state.app.audios,
  loading: state.app.audiosLoading,
});

export default connect(mapStateToProps)(Screen);
